module.exports = __webpack_public_path__ + "img/arrow-filled.c2935856.svg";